import { useEffect } from 'react';
import './Backdrop.css';

type BackdropProps = {
  trackIndex: number;
  isPlaying: boolean;
  image: string;
};

export const Backdrop = ({
  trackIndex,
  isPlaying,
  image,
}: BackdropProps) => {
  useEffect(() => {
    document.documentElement.style.setProperty('--active-color', "#C8C8C8");
  }, [trackIndex]);

  return (
    <div className={`color-backdrop ${isPlaying ? 'playing' : 'idle'}`}>
      <img
          className="artwork2"
          src={image}
          alt=''
        />
    </div>
  );
};
